import React from 'react';
import { Box } from '@mui/material';

export default function SectionHeader({ title, light = false }) {
    return (
        <Box
            sx={{
                width: '100%',
                height: 52,
                gap: 16,
                pt: 1.5,
                px: 3,
                pb: 1.5,
                borderRadius: "8px",
                bgcolor: light ? '#E8EAEE' : '#647490',
                boxShadow: '-2px 2px 5px 0px #00000040',
                color: light ? 'black' : 'white',
                fontSize: '1.2rem',
                fontWeight: 'bold',
                mt: 3
            }}
        >
            {title}
        </Box>
    );
}